import { cpf } from 'cpf-cnpj-validator';
import { StringSchema } from 'yup';

export default function cpfValidation(this: StringSchema, message: string) {
  return this.test('cpf', message, (value) => cpf.isValid(value));
}
